import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';
import TitleDescription from '../common/TitleDescription';
import { FeatureCard } from './FeatureCard';

export function FeatureCards({ cards = [], title, description, gridClassName }) {
    return (
        <section>
            <div className='container mx-auto px-5 py-12'>
                {(title || description) && (
                    <TitleDescription alignment='text-center' title={title} description={description} />
                )}
                <div
                    className={twMerge(
                        classNames(
                            'grid grid-cols-1 gap-16',
                            cards.length === 2 && 'lg:grid-cols-2',
                            cards.length === 3 && 'lg:grid-cols-3',
                            gridClassName,
                        ),
                    )}
                >
                    {cards.map((card, index) => (
                        <FeatureCard key={index} {...card} />
                    ))}
                </div>
            </div>
        </section>
    );
}
